import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslateTitleStrategy extends TitleStrategy {
    private readonly _title = inject(Title);
    private readonly _translate = inject(TranslateService);

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const key = this.buildTitle(snapshot);
        if (key) {
            this._translate.get(key).subscribe((translated) => {
                this._title.setTitle(translated);
            });
        }
    }
}
